import script from "./CountdownTimer.vue?vue&type=script&setup=true&lang=ts"
export * from "./CountdownTimer.vue?vue&type=script&setup=true&lang=ts"

import "./CountdownTimer.vue?vue&type=style&index=0&id=8c89ae60&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c89ae60"]])

export default __exports__